export default __webpack_public_path__ + "static/media/1919.ff6f95bf.png";